export default __webpack_public_path__ + "static/assets/med_pill_triangle_out_L0_solid_x_01_f_mask.8c402c8f.png";